import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { openNotification } from "src/components/helpers/notification";
import ax from "src/store/config";

const initialState = {
  personalTrainingsList: null,
  personalTrainingsListLoading: false,
};

export const personalTrainingsAction = createAsyncThunk(
  "personalTrainingsAction",
  async (payload, { dispatch }) => {
    dispatch(setPersonalTrainingsListLoading(true));
    try {
      let data;
      switch (payload.flag) {
        case "get":
          ({ data } = await ax.get("/api/admin/directory/personalTrainings", {
            params: payload.value,
          }));
          data && dispatch(setPersonalTrainingsListLoading(false));
          return data;
        case "delete":
          ({ data } = await ax.delete(
            "/api/admin/directory/personalTrainings",
            { params: payload.value }
          ));
          data &&
            openNotification({
              type: "success",
              message: `Тренировка успешно удалена`,
            });
          break;
        default:
          break;
      }
    } catch (error) {
      dispatch(setPersonalTrainingsListLoading(false));
      openNotification({
        type: "error",
        message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`,
      });
      return error;
    }
  }
);

const PersonalTrainingsSlice = createSlice({
  name: "personalTrainingsTable",
  initialState,
  reducers: {
    setPersonalTrainingsListLoading: (state, action) => {
      state.personalTrainingsListLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(personalTrainingsAction.fulfilled, (state, action) => {
      state.personalTrainingsList = action.payload;
    });
  },
});

export const { setPersonalTrainingsListLoading } =
  PersonalTrainingsSlice.actions;

export default PersonalTrainingsSlice.reducer;
